import { SignoffConfigForStep } from '.';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function createSelfSignoffConfigForStep(
   stepId: number,
   common: CommonRequestOptions = {}
): Promise<SignoffConfigForStep> {
   return makeRequest('put', `/signoffs/${stepId}/signoff/SELF_SIGNOFF`, {
      ...common,
      body: {},
   });
}
